import { defineComponent as _defineComponent } from 'vue'
import { Picture, Typo } from '@travelata-libs/ui-kit';
  import { pluralize } from '@travelata-libs/utils';
  import { computed } from 'vue';
  import { PARTNERS_WORD_FORMS, SQUARE_LOGO_OPERATOR_IDS } from '../config';
  import { getProviderLogo } from '../lib/getProviderLogo';
  import useRoomProviders from '../lib/useRoomProviders';
  import { RoomProvidersSummaryContext, type ProviderOffer } from '../model/types';

  interface RoomProvidersSummaryProps {
    offers: ProviderOffer[];
    context?: RoomProvidersSummaryContext;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomProvidersSummary',
  props: {
    offers: null,
    context: { default: RoomProvidersSummaryContext.Room }
  },
  setup(__props: any) {

const props = __props as { offers: ProviderOffer[], context: RoomProvidersSummaryContext }

  
  const { providers, offersCountText } = useRoomProviders(() => props.offers);

  const MAX_SUMMARY_LOGOS = 2;
  const summaryLogos = computed(() => providers.value.slice(0, MAX_SUMMARY_LOGOS));

  const isHotelContext = computed(() => props.context === RoomProvidersSummaryContext.Hotel);
  const partnersText = computed(() => `от ${pluralize(PARTNERS_WORD_FORMS, providers.value.length)}`);

return { __sfc: true,props, providers, offersCountText, MAX_SUMMARY_LOGOS, summaryLogos, isHotelContext, partnersText, Picture, Typo, SQUARE_LOGO_OPERATOR_IDS, getProviderLogo }
}

})